/* tslint:disable:max-line-length component-class-suffix */

import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  SetSharedDataAction
} from '../../../store/actions/shared-data.action';
import { isNil } from 'lodash';
import { Vehicle } from '../../../../lib/angular/model/vehicle/vehicle';
import { DDMenuEnableDisableService } from '../../../shared/service/common/dd-menu-enable-disable.service';
// Store
//
import { Store } from '@ngrx/store';
import { Action } from '../../../../lib/core/common/action';
import {
  IAppState,
  SharedDataStore,
  ProtectionProductStore
} from '../../../store/index';
import { OmnitureTags } from 'src/app/shared/omnitureTags';
import * as Library from '../../../../lib/core/library/index';


@Component({
  providers: [OmnitureTags],
  selector: 'dd-v-spec-protection-product-detail',
  templateUrl: './v-spec-protection-product-detail.html',
  styleUrls: ['./v-spec-protection-product-detail.scss']
})

export class VSpecProtectionProductDetail implements OnInit, AfterViewInit, OnDestroy {

  //
  // Public
  //
  @ViewChild('videoViewer') public videoViewer;
  public vehicle: Vehicle;
  public shared: any;
  public selectedproduct: any;
  public actualPlanId: any;
  public salesClass: any;
  public plan = new Array<any>();
  public allPlans: any;
  public overViewContent: string = "";
  public benifitsContent: string = "";
  public browcherURL: string = "";
  public elegibliltyContent: string = "";
  public dialogActions: Action[];
  public handleVideoEvent: any;
  public videoURL: any;
  public disclaimer: string = "";
  public productTag: any={};
  public transactionType: string;
  ngAfterContentInit() {

  }
  ngAfterViewInit() {

  }
  //
  // OnInit
  //
  ngOnInit() {
    //
    // Get access to the parent data
    //
    this._route.parent.data.subscribe((params: any) => {
      //
      // Get Vehicle Information
      //
      this.vehicle = params['data'];

      //
      // Listen for Shared Data
      //
      this._store.select(SharedDataStore).subscribe(data => {
        this.shared = Object.assign({}, data, {
          vehicleDetails: this.vehicle,
          currentVin: this.vehicle.vin
        });
      });

      //
      // Save Shared Data
      //
      this._store.dispatch(new SetSharedDataAction(this.shared));
      this._ddMenuEnableDisableService.loadFeatureConfigData(this.vehicle);
      this._ddMenuEnableDisableService.loadProtectionProducts(this.shared);
      this.loadPlanDetails("");
      var elmnt = document.getElementById("divToScroll");
      if(!isNil(elmnt))
      elmnt.scrollIntoView();
    });

  }
  loadPlanDetails(planId: any) {

    let self = this;
    this._store.select(ProtectionProductStore).subscribe(data => {
      let dealers: any;
      let product: any;
      dealers = data.items;
      this.actualPlanId = this._route.snapshot.paramMap.get("planId");
      this.transactionType=this._route.snapshot.paramMap.get("transactionType");
      this.videoURL = this._route.snapshot.paramMap.get("videoURL");
      this.selectedproduct = {
        "productId": this._route.snapshot.paramMap.get("productId"),
        "planId": this._route.snapshot.paramMap.get("planId"),
        "displayName": this._route.snapshot.paramMap.get("displayName"),
        "timeMileage": this._route.snapshot.paramMap.get("timeMileage"),
        "deductible": this._route.snapshot.paramMap.get("deductible"),
        "customerPrice": this._route.snapshot.paramMap.get("customerPrice"),
        "monthlyPayment": this._route.snapshot.paramMap.get("monthlyPayment"),
      };
      if (dealers.dealers.length > 0) {
        product = dealers.dealers.filter(function (item) {
          return item.productId == self.selectedproduct.productId;
        });
        let salesClassArray = product[0].salesClasses.salesClass;
        this.plan = [];

        if (salesClassArray.length > 1) {
          this.salesClass = salesClassArray.filter(function (item) {
            return item.id == "New Vehicle";
          });
        }
        else {
          this.salesClass = salesClassArray;

        }
        this.plan = this.salesClass[0].plans.plan.filter(function (item) {
          if (self.actualPlanId == item.id) {
            self.actualPlanId = item.displayName;
          }
          if (planId != "") {
            self.selectedproduct.planId = planId;
            return item.id == self.selectedproduct.planId;
          } else {
            return item.id == self.selectedproduct.planId;
          }

        });
        this.allPlans = this.salesClass[0].plans.plan;
        if (this.plan.length > 0) {
          this.benifitsContent = (!isNil(this.plan[0].content) && !isNil(this.plan[0].content.benefitsTextUrl))?this.plan[0].content.benefitsTextUrl:"";
          this.elegibliltyContent = (!isNil(this.plan[0].content) && !isNil(this.plan[0].content.eligibilityDescriptionTextUrl))?this.plan[0].content.eligibilityDescriptionTextUrl:"";
          this.overViewContent = (!isNil(this.plan[0].content) && !isNil(this.plan[0].content.planOverviewTextUrl))?this.plan[0].content.planOverviewTextUrl:"";
          this.disclaimer =  (!isNil(this.plan[0].content) && !isNil(this.plan[0].content.disclaimersTextUrl))?"Disclaimers: " +this.plan[0].content.disclaimersTextUrl:"";
          this.productTag.marketingName = this.selectedproduct.productId + " " + this.plan[0].displayName;
          this.productTag.partNbr =  this.plan[0].id;
          this.browcherURL = (!isNil(this.plan[0].content) && !isNil(this.plan[0].content.brochurePDFUrl))?this.plan[0].content.brochurePDFUrl:"";
         

        }


      }
    });



  }
  selectTab(planId: any) {
    this.loadPlanDetails(planId);
    this.omTag.fireOmnitureTag('vpp_aa-subpageload', { url: '', href: '', text: '', trigger: '', listIndex: '', part: this.productTag }, this.shared);
  }
  playVideo() {
    this.omTag.fireOmnitureTag('vp_aa-link', { url: this.videoURL, href: this.videoURL, text: 'view_video', trigger: 'aa-link', listIndex: '', part: this.productTag }, this.shared);
    if (Library.isDefined(this.handleVideoEvent)) {
      this.handleVideoEvent.onClick.emit("");
    }
  }
  //
  // ngOnDestroy
  //
  ngOnDestroy() {

  }


  //
  // Constructor
  //
  constructor(
    private _store: Store<IAppState>,
    private _route: ActivatedRoute,
    private _router: Router,
    public omTag: OmnitureTags,
    private _ddMenuEnableDisableService: DDMenuEnableDisableService,
  ) {
    (this.handleVideoEvent = {
      onClick: new EventEmitter<any>(),
      hidden: false
    }),
      (this.dialogActions = null);


  }
  navigateToProducts() {
    let idObject={
      "index":this._route.snapshot.paramMap.get("index"),
    }
    this._router.navigate([`/v-spec/${this.vehicle.vin}/protectionproducts`, idObject] ,{ skipLocationChange: true });
  }

}
